import { Section } from '@shared/Section'
import { useCases } from '@features/landing/content'

export function UseCases() {
  return (
    <Section
      id="use-cases"
      eyebrow="Use cases"
      title="Where teams point it first"
      description="Anywhere you already wish you had talked to more customers — and could not afford the hours."
    >
      <div className="grid grid-cols-1 gap-x-10 gap-y-8 sm:grid-cols-2">
        {useCases.map((useCase) => (
          <div
            key={useCase.title}
            className="border-l-2 border-blue-600/40 pl-5 dark:border-blue-300/40"
          >
            <h3 className="text-lg font-semibold text-foreground">{useCase.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{useCase.body}</p>
          </div>
        ))}
      </div>
    </Section>
  )
}
